import apiService from '@/services/apiService';

const actions = {
  getCustomerList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`mitrapaxel?filter=status:${payload.status},created_at.$gte:${payload.date_from},created_at.$lte:${payload.date_to}&${payload.page}&${payload.limit}&sort_by=${payload.sort_by}&${payload.search_param}`)
        .then((response) => {
          // commit('getCustomerList', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCustomerListId({ commit }, payload) {
    apiService.get(`mitrapaxel/${payload}`)
      .then((response) => {
        commit('getCustomerListId', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  putMitraStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`mitrapaxel/status/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;
